import { z } from 'zod'

export const keyboardShortcutTriggeredSchema = z.object({
  shortcut: z.string(),
  group: z.string(),
})
